import { Button } from '@material-tailwind/react'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import Table from '../../../components/common/agGrid'
import practiceService, { Practice } from '../../../Services/practice.services'
import CreatePracticeDialog from './CreatePracticeDialog'
import RenamePracticeDialog from './RenamePracticeDialog'
import DeletePracticeDialog from './DeletePracticeDialog'
import PracticeDentistsDialog from './PracticeDentistsDialog'

// The Search box filters by practice name only, so the other columns give it no text to match
const notSearched = () => ''

const PracticeList = () => {
  const [practices, setPractices] = useState<Practice[]>([])
  const [dataLoaded, setDataLoaded] = useState(false)
  const [selectedPractice, setSelectedPractice] = useState<Practice>()
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [isRenameOpen, setIsRenameOpen] = useState(false)
  const [isDeleteOpen, setIsDeleteOpen] = useState(false)
  const [isDentistsOpen, setIsDentistsOpen] = useState(false)

  useEffect(() => {
    GetPractices()
  }, [])

  const GetPractices = async () => {
    const result = await practiceService.GetPractices()
    if (!result.success) {
      toast.error('Could not load practices. Please try again later.', { position: 'top-center' })
    }
    setPractices(result.data)
    setDataLoaded(true)
  }

  const columns = [
    { headerName: 'Name', field: 'name' },
    { headerName: 'State', field: 'stateName', getQuickFilterText: notSearched },
    { headerName: 'Dentists', field: 'dentistCount', getQuickFilterText: notSearched },
    {
      headerName: 'Manage dentists',
      field: 'dentists',
      sortable: false,
      filter: false,
      getQuickFilterText: notSearched,
      valueFormatter: () => 'Dentists',
      cellStyle: { color: 'blue', 'text-decoration': 'underline' },
    },
    {
      headerName: 'Rename',
      field: 'rename',
      sortable: false,
      filter: false,
      getQuickFilterText: notSearched,
      valueFormatter: () => 'Rename',
      cellStyle: { color: 'blue', 'text-decoration': 'underline' },
    },
    {
      headerName: 'Delete',
      field: 'delete',
      sortable: false,
      filter: false,
      getQuickFilterText: notSearched,
      valueFormatter: () => 'Delete',
      cellStyle: { color: 'blue', 'text-decoration': 'underline' },
    },
  ]

  const stateManager = () => {
    setIsCreateOpen(false)
    setIsRenameOpen(false)
    setIsDeleteOpen(false)
    setIsDentistsOpen(false)
  }

  const getSelectedPractice = (cell: any) => {
    if (cell.column.colId == 'dentists') {
      setSelectedPractice(cell.data)
      setIsDentistsOpen(true)
    } else if (cell.column.colId == 'rename') {
      setSelectedPractice(cell.data)
      setIsRenameOpen(true)
    } else if (cell.column.colId == 'delete') {
      setSelectedPractice(cell.data)
      setIsDeleteOpen(true)
    }
  }

  return (
    <div>
      <div className="mx-auto px-4 sm:px-8 flex-grow">
        <div className="py-5">
          <div className="flex flex-row mb-1 sm:mb-0 justify-between w-full">
            <h1 className="text-2xl leading-tight text-3xl">Practices</h1>
            <Button className="flex items-center" onClick={() => setIsCreateOpen(true)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              New Practice
            </Button>
          </div>
          <p>A practice's answers are filled in once and shared by its dentists.</p>
        </div>
      </div>
      <div>
        {dataLoaded ? (
          <Table rowData={practices} columns={columns} getOnclickCellData={getSelectedPractice} />
        ) : (
          <p>Loading...</p>
        )}
        <CreatePracticeDialog isOpen={isCreateOpen} stateManager={stateManager} GetPractices={GetPractices} />
        <RenamePracticeDialog isOpen={isRenameOpen} stateManager={stateManager} data={selectedPractice} GetPractices={GetPractices} />
        <PracticeDentistsDialog isOpen={isDentistsOpen} stateManager={stateManager} data={selectedPractice} GetPractices={GetPractices} />
        <DeletePracticeDialog isOpen={isDeleteOpen} stateManager={stateManager} data={selectedPractice} GetPractices={GetPractices} />
      </div>
    </div>
  )
}

export default PracticeList
